// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

/**
 * for creating, we want: level, user_id
 * for response, we want: id, user data, team
 * We want id, user object, and team data response
 * need to use to_representation or form_represenation
 */
export function inviteCreate(params: {
  emails: ReadonlyArray<string>
  level: "admin" | "contributor" | "read"
  team_id: number
}) {
  return http<{
    invite_ids: Array<number>
  }>({
    url: "/api/v1/t/{team_id}/invites/",
    method: "post",
    params,
    pathParamNames: ["team_id"],
  })
}
